import { Button as BaseButton } from "@base-ui/react/button";
import { type ComponentProps } from "react";
import { IconChevronRight } from "@tabler/icons-react";
import styles from "./Button.module.css";
// @ts-expect-error pure js
import { classnames } from "../../utils";
import Tooltip from "./Tooltip";
import useCanWrite from "../../hooks/use-can-write";
import { READ_ONLY_MESSAGE } from "../../utils/permissions";

type ButtonVariant = "primary" | "secondary" | "tertiary";

interface ButtonCardProps extends ComponentProps<typeof BaseButton> {
  variant?: ButtonVariant;
  selected?: boolean;
  requiresWrite?: boolean;
  profileId?: number | null;
}

export default function ButtonCard({
  variant = "secondary",
  selected,
  className,
  children,
  type = "button",
  disabled,
  requiresWrite,
  profileId,
  ...props
}: ButtonCardProps) {
  const writable = useCanWrite(profileId);
  const blocked = requiresWrite === true && !writable;

  const button = (
    <BaseButton
      className={classnames(
        styles.button,
        styles[variant],
        selected && styles.selected,
        className,
      )}
      type={type}
      disabled={blocked || disabled}
      {...props}
    >
      <div className={styles.buttonCardContent}>
        <span>{children}</span>
        <IconChevronRight size={16} stroke={1.5} />
      </div>
    </BaseButton>
  );

  if (blocked) {
    return <Tooltip content={READ_ONLY_MESSAGE}>{button}</Tooltip>;
  }
  return button;
}
